import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FormInputFile } from "../../../components/FormInputFile";
import ImagePDFComponent from "../../../components/ImagePDFComponent";
import { SystemLoading, checkLoading } from "../../../store/loadingStore";
import { handleFileDownloadRes } from "../../../utility/service/api-base";
import { downloadMultipartFile } from "../../../utility/service/api-file";

const FileAttachmentHandler = ({
  id,
  data,
  isEditable,
  fileInputRef,
  onFileChange,
  onFileDelete,
  label,
  register,
  errors,
  wrapperClass = "",
  wrapperStyle = {},
  imagePDFWrapperClass = "",
}) => {
  const { t } = useTranslation();
  const [, loading] = useContext(SystemLoading);

  const handleDownload = () => {
    if (!data?.fileId) return;
    checkLoading(loading);
    downloadMultipartFile({ fileId: data.fileId })
      .then((res) => {
        if (res?.status === 200) {
          handleFileDownloadRes(res, `${data.fileName || "file"}.zip`);
        }
      })
      .finally(() => checkLoading(loading, false));
  };

  return (
    <>
      {label && <label className="form-label">{label}</label>}
      <div className={`grid ${wrapperClass}`}>
        <div className={`col-12 ${data?.fileId && !isEditable ? "lg:col-6" : ""}`}>
          <FormInputFile
            register={register}
            errors={errors}
            fileInputRef={fileInputRef}
            id={id}
            name={id}
            limitSize="20MB"
            acceptFileType=".jpg,.png,.pdf,.zip"
            disabled={isEditable}
            fileChange={onFileChange}
            wrapperClass={`${imagePDFWrapperClass}`}
          />
        </div>
        {data?.fileId && (
          <div className="col-12 lg:col-6">
            {data.fileExtension !== "zip" ? (
              <ImagePDFComponent
                imgHeight="100"
                imgWidth="100"
                disabled={isEditable}
                file={data.fileInfo}
                zoomSrc={data.zoomSrc}
                previewUrl={data.fileExtension === "pdf" ? data.filePath : data.filePathSml}
                deleteImg={onFileDelete}
              />
            ) : (
              <>
                <span className="text-sm px-2">{data.fileName}.zip</span>
                <div className="flex align-items-center gap-3">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    className="p-button-danger p-button-text p-0 w-2rem h-2rem"
                    disabled={isEditable}
                    onClick={onFileDelete}
                  />
                  <Button
                    type="button"
                    className="p-button-secondary p-button-text p-0 w-2rem h-2rem"
                    onClick={handleDownload}
                  >
                    <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
                  </Button>
                </div>
              </>
            )}

            {!["pdf", "zip"].includes(data.fileExtension) && data.fileExtension && (
              <small className="text-secondary">
                {data.fileName}.{data.fileExtension}
              </small>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default FileAttachmentHandler;
